export default "__VITE_ASSET__5c28da36__"